import React, { lazy } from "react";
import DashboardLayout from "pages/admin/DashboardLayout";
import { ADMIN_NAV } from "./APP_ROUTES";
import { useAuth } from "provider/AuthContext";
import { Navigate } from "react-router-dom";

export default function PrivateRoutes() {
  const { user } = useAuth();
  const isUserRole = user?.role === "User";

  const adminNavItems = ADMIN_NAV();
  return {
    path: "/",
    element: <DashboardLayout />,
    children: [
      ...(user && !isUserRole
        ? [
            ...adminNavItems.map(({ path, component, index }) => ({
              index,
              path: "/admin" + path,
              element: component,
            })),
          ]
        : []),
      // Redirect unknown routes to the home page
      { path: "*", element: <Navigate to="/" /> },
    ],
  };
}
